export const languages = [
    {
        country:'Afghanistan'
    },
    {
        country:'Albania'
    },
    {
        country:'Algeria'
    },
    {
        country:'American Samoa'
    },
    {
        country:'Andorra'
    },
    {
        country:'Anguilla'
    },
    {
        country:'Antartica'
    },
    {
        country:'Antigua & Barbuda'
    },
    {
        country:'Argentina'
    },
    {
        country:'Armenia'
    },
    {
        country:'Aruba'
    },
    {
        country:'Australia'
    },
    {
        country:'Azerbaijan'
    },
    {
        country:'Bahamas'
    },
    {
        country:'Bahrain'
    },
    {
        country:'Bangaladesh'
    },
    {
        country:'Barbados'
    },
    {
        country:'Belarus'
    },
    {
        country:'Belgium'
    },
    {
        country:'Belize'
    },
    {
        country:'Benin'
    },
    {
        country:'Bhutan'
    },
    {
        country:'Bhutan'
    },
    {
        country:'Bolivia'
    },
    {
        country:'Bosina & Herzegovina'
    },
    {
        country:'Botswana'
    },
    {
        country:'Bouvet Island'
    },
    {
        country:'Brazil'
    },
    {
        country:'British Indian Ocean Territory'
    }

]